import { React, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import { Modal, Box } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";

import EditIcon from "@material-ui/icons/Edit";
import EmailIcon from "@material-ui/icons/Email";
import LockIcon from "@material-ui/icons/Lock";
import SchoolIcon from "@material-ui/icons/School";
import DescriptionIcon from "@material-ui/icons/Description";

import imgAp from "../../../assets/img/imgLogin.jpg";

import Header from "../../../components/header";
import Footer from "../../../components/footer";
import MenuPerfil from "../../../components/menuPerfil";

import * as ProfessionalsServices from "../../../services/api/ProfessionalsServices";
import { useUserContext } from "../../../providers/useUserContext";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 420,
  maxWidth: "90%",
  bgcolor: "#fff",
  borderRadius: "16px",
  boxShadow: 24,
  p: 4,
};

const useStyles = makeStyles((theme) => ({
  wrapper: {
    backgroundColor: "#F8F8FA",
    minHeight: "60vh",
  },
  layout: {
    display: "flex",
    alignItems: "flex-start",
    gap: 28,
    maxWidth: 1180,
    margin: "36px auto",
    padding: "0 24px",
    "@media (max-width: 900px)": {
      flexDirection: "column",
      gap: 18,
    },
  },
  sidebarCol: {
    width: 280,
    flexShrink: 0,
    position: "sticky",
    top: 24,
    "@media (max-width: 900px)": {
      width: "100%",
      position: "static",
    },
  },
  content: {
    flex: 1,
    width: "100%",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: 16,
    boxShadow: "0 8px 30px rgba(0, 0, 0, 0.06)",
    padding: 36,
    "@media (max-width: 600px)": {
      padding: 24,
    },
  },
  pageHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 28,
    flexWrap: "wrap",
    gap: 12,
  },
  title: {
    color: "#2b2f36",
    fontFamily: "Montserrat",
    fontSize: 26,
    fontWeight: 800,
  },
  editButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    backgroundColor: "#54B5CF",
    color: "#fff",
    fontFamily: "Montserrat",
    fontSize: 14,
    fontWeight: 600,
    borderRadius: 24,
    padding: "10px 22px",
    textDecoration: "none",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#0facc4",
      color: "#fff",
      textDecoration: "none",
    },
  },
  profileTop: {
    display: "flex",
    alignItems: "center",
    gap: 28,
    paddingBottom: 28,
    borderBottom: "1px solid #eef0f2",
    "@media (max-width: 600px)": {
      flexDirection: "column",
      textAlign: "center",
      gap: 16,
    },
  },
  avatar: {
    width: 140,
    height: 140,
    borderRadius: "50%",
    objectFit: "cover",
    border: "4px solid #eef6f9",
    boxShadow: "0 6px 20px rgba(84, 181, 207, 0.25)",
    flexShrink: 0,
  },
  name: {
    color: "#2b2f36",
    fontFamily: "Montserrat",
    fontSize: 24,
    fontWeight: 800,
  },
  roleRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    color: "#54B5CF",
    fontFamily: "Montserrat",
    fontSize: 15,
    fontWeight: 600,
    marginTop: 6,
    "@media (max-width: 600px)": {
      justifyContent: "center",
    },
  },
  infoGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 22,
    marginTop: 28,
    "@media (max-width: 600px)": {
      gridTemplateColumns: "1fr",
    },
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  fieldLabel: {
    display: "flex",
    alignItems: "center",
    gap: 7,
    color: "#9aa0a6",
    fontFamily: "Montserrat",
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: "0.06em",
  },
  fieldValue: {
    color: "#3b4148",
    fontFamily: "Roboto",
    fontSize: 17,
    fontWeight: 400,
    wordBreak: "break-word",
  },
  fieldIcon: {
    fontSize: 17,
    color: "#54B5CF",
  },
  curriculumBox: {
    marginTop: 28,
    padding: "20px 24px",
    borderRadius: 12,
    backgroundColor: "#f3fafc",
    border: "1px solid #e2f1f6",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 12,
  },
  curriculumText: {
    color: "#3b4148",
    fontFamily: "Montserrat",
    fontSize: 15,
    fontWeight: 600,
  },
  curriculumLink: {
    color: "#54B5CF",
    fontFamily: "Montserrat",
    fontSize: 14,
    fontWeight: 600,
    textDecoration: "none",
    "&:hover": { textDecoration: "underline" },
  },
  modalTitle: {
    fontFamily: "Montserrat",
    fontWeight: 800,
    color: "#54B5CF",
  },
  modalText: {
    fontFamily: "Roboto",
    color: "#5a6472",
    marginTop: 12,
  },
  modalButton: {
    display: "inline-block",
    marginTop: 20,
    textDecoration: "none",
    backgroundColor: "#54B5CF",
    color: "#fff",
    borderRadius: 24,
    padding: "10px 24px",
    fontFamily: "Montserrat",
    fontWeight: 600,
    fontSize: 15,
    "&:hover": { backgroundColor: "#0facc4" },
  },
}));

export default function Perfil() {
  const classes = useStyles();
  const user = useUserContext();
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    (async () => {
      const resp = await ProfessionalsServices.getProfile();
      setProfile(resp.data);
    })();
  }, []);

  useEffect(() => {
    if (user) {
      (async () => {
        const resp = await ProfessionalsServices.getProfile();
        setProfile(resp.data);
      })();
    }
  }, [user]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (profile) {
        if (profile?.crfa !== undefined) {
          handleClose();
        } else {
          handleOpen();
        }
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, [profile]);

  const editLink = `/admin/profissional/profissionalEditar/${profile?.id}`;

  return (
    <div className={classes.wrapper}>
      <Header />

      {profile?.crf === undefined && (
        <Modal open={open} onClose={handleClose}>
          <Box sx={modalStyle}>
            <Typography className={classes.modalTitle} variant="h6" component="h2">
              Complete seu cadastro
            </Typography>
            <Typography className={classes.modalText}>
              Sua conta ainda não está visível na busca de profissionais. Termine
              o seu cadastro para que seus dados sejam disponibilizados na
              plataforma.
            </Typography>
            <a href={editLink} className={classes.modalButton}>
              Editar perfil
            </a>
          </Box>
        </Modal>
      )}

      <div className={classes.layout}>
        <div className={classes.sidebarCol}>
          <MenuPerfil />
        </div>

        <div className={classes.content}>
          <div className={classes.card}>
            <div className={classes.pageHeader}>
              <Typography className={classes.title}>Meu Perfil</Typography>
              <Link to={editLink} className={classes.editButton}>
                <EditIcon style={{ fontSize: 18 }} />
                Editar Perfil
              </Link>
            </div>

            <div className={classes.profileTop}>
              <img
                src={profile?.picture || imgAp}
                alt="Foto do perfil"
                className={classes.avatar}
              />
              <div>
                <Typography className={classes.name}>
                  {profile?.name || "—"}
                </Typography>
                <div className={classes.roleRow}>
                  <SchoolIcon style={{ fontSize: 18 }} />
                  {profile?.formation || "Formação não informada"}
                  {profile?.crfa ? ` · ${profile.crfa}` : ""}
                </div>
              </div>
            </div>

            <div className={classes.infoGrid}>
              <div className={classes.field}>
                <span className={classes.fieldLabel}>
                  <EmailIcon className={classes.fieldIcon} />
                  E-MAIL DA CONTA
                </span>
                <span className={classes.fieldValue}>
                  {profile?.email || "—"}
                </span>
              </div>

              <div className={classes.field}>
                <span className={classes.fieldLabel}>
                  <LockIcon className={classes.fieldIcon} />
                  SENHA
                </span>
                <span className={classes.fieldValue}>****************</span>
              </div>
            </div>

            <div className={classes.curriculumBox}>
              <span className={classes.curriculumText}>
                <DescriptionIcon
                  style={{ fontSize: 18, color: "#54B5CF", verticalAlign: "middle", marginRight: 8 }}
                />
                Mantenha seu currículo sempre atualizado
              </span>
              <Link to={editLink} className={classes.curriculumLink}>
                Editar meu currículo →
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
